export var classNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    if (!classNames || classNames.length === 0)
        return '';
    return classNames.join(' ');
};
export var ellipsisDescription = function (text, limit) {
    text = text !== null && text !== void 0 ? text : '';
    var returnText = text.length > limit ? text.slice(0, limit) + '...' : text;
    return returnText;
};
//# sourceMappingURL=style-class.utils.js.map